'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _fixedDataTable = require('fixed-data-table-2');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
export default function textCellComponent(props) {
    let {
        height,
          width,
          style,
          className,
          align,
          sand,
          value,
          dataType,
          precision,
          enableTooltip,
          enableEllipsis,
          ...other
    } = props

      let cls = classNames({
          'mk-datagrid-cellContent': true,
          [`mk-datagrid-cellContent-${align}`]: !!align,
          [className]: !!className
      })

      let innerStyle = {
          height,
          width,
          ...style,
      }

      switch (dataType) {
          case 'bool':
              value = (value == undefined || value == false) ? '否' : '是'
              break
          case 'float':
              if (precision && (!!value)) {
                  value = parseFloat(value).toFixed(precision)
              }
              break
      }

      if (value == null || value == undefined) {
          value = ''
      }

      value = value + ''

      if (sand) {
          value = sand(value)
      }

      let ext = {}
      if (enableTooltip) {
          ext.title = value
      }


      if (enableEllipsis) {
          ext.title = value
          value = [<span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{value}</span>]
      }



      return (
          <div {...other} className={cls} style={innerStyle} {...ext}>
              {value}
          </div>
      )
}*/

var textCellComponent = function (_React$PureComponent) {
    (0, _inherits3.default)(textCellComponent, _React$PureComponent);

    function textCellComponent() {
        (0, _classCallCheck3.default)(this, textCellComponent);
        return (0, _possibleConstructorReturn3.default)(this, (textCellComponent.__proto__ || (0, _getPrototypeOf2.default)(textCellComponent)).apply(this, arguments));
    }

    (0, _createClass3.default)(textCellComponent, [{
        key: 'render',
        value: function render() {
            var _classNames;

            var _props = this.props,
                height = _props.height,
                width = _props.width,
                style = _props.style,
                className = _props.className,
                align = _props.align,
                sand = _props.sand,
                value = _props.value,
                dataType = _props.dataType,
                precision = _props.precision,
                enableTooltip = _props.enableTooltip,
                enableEllipsis = _props.enableEllipsis,
                other = (0, _objectWithoutProperties3.default)(_props, ['height', 'width', 'style', 'className', 'align', 'sand', 'value', 'dataType', 'precision', 'enableTooltip', 'enableEllipsis']);


            var cls = (0, _classnames2.default)((_classNames = {
                'mk-datagrid-cellContent': true
            }, (0, _defineProperty3.default)(_classNames, 'mk-datagrid-cellContent-' + align, !!align), (0, _defineProperty3.default)(_classNames, className, !!className), _classNames));

            var innerStyle = (0, _extends3.default)({
                height: height,
                width: width
            }, style);

            switch (dataType) {
                case 'bool':
                    value = value == undefined || value == false ? '否' : '是';
                    break;
                case 'float':
                    if (precision && !!value) {
                        value = parseFloat(value).toFixed(precision);
                    }
                    break;
            }

            if (value == null || value == undefined) {
                value = '';
            }

            value = value + '';

            if (sand) {
                value = sand(value);
            }

            var ext = {};
            if (enableTooltip) {
                ext.title = value;
            }

            if (enableEllipsis) {
                ext.title = value;
                value = [_react2.default.createElement(
                    'span',
                    { style: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' } },
                    value
                )];
            }

            return _react2.default.createElement(
                'div',
                (0, _extends3.default)({}, other, { className: cls, style: innerStyle }, ext),
                value
            );
        }
    }]);
    return textCellComponent;
}(_react2.default.PureComponent);

exports.default = textCellComponent;
module.exports = exports['default'];